import { render, staticRenderFns } from "./ClientsSection.vue?vue&type=template&id=e302c24c&scoped=true&"
import script from "./ClientsSection.vue?vue&type=script&lang=js&"
export * from "./ClientsSection.vue?vue&type=script&lang=js&"
import style0 from "./ClientsSection.vue?vue&type=style&index=0&id=e302c24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e302c24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
